import React from "react";
import { Link } from "react-router-dom";

const Cards2 = ({ image, title, subtitle, url}) => {
  return (
    <Link to={`/produit/${url}`}>
      <div className="relative w-full group overflow-hidden rounded-xl">
          <img
              src={image}
              className="object-cover w-64 h-[450px] transform transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#00000000] to-[#0000008f]"></div>
          <div className="absolute bottom-20 left-0 right-0 px-4 text-white">
              <h2 className="font-customFont1 text-3xl font-extrabold">{title}</h2>
              <p className="font-customFont2 text-sm font-light">{subtitle}</p>
          </div>
      </div>
    </Link>
  );
};

export default Cards2;
